import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";

const DeveloperApplications = () => {
  const applications = [
    {
      id: 1,
      company: "Tech Corp",
      position: "Senior React Developer",
      status: "Under Review",
      appliedDate: "2024-02-20",
    },
    {
      id: 2,
      company: "Innovation Labs",
      position: "Full Stack Developer",
      status: "Interview Scheduled",
      appliedDate: "2024-02-18",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle>My Applications</CardTitle>
          </CardHeader>
          <CardContent>
            <ScrollArea className="h-[600px] pr-4">
              <div className="space-y-4">
                {applications.map((application) => (
                  <Card key={application.id}>
                    <CardContent className="p-4">
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="font-semibold text-lg">{application.position}</h3>
                          <p className="text-sm text-gray-600">{application.company}</p>
                          <p className="text-sm text-gray-500">Applied: {application.appliedDate}</p>
                        </div>
                        <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-sm">
                          {application.status}
                        </span>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </ScrollArea>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DeveloperApplications;